import { DocumentMode } from '@root/@types/types';

import type { TransitionConfigMap } from '../types';

export const REVIEW_TRANSITIONS: TransitionConfigMap = {
  DRAFT: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Return to Draft state?',
      content:
        'Setting this contract back to Draft will make it editable again. It must then be returned to Review to complete the review process.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Return to Draft state?',
      content:
        'Setting this template back to Draft will make it editable again. It must then be returned to Review for Super Admin sign-off.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Return to Draft state?',
      content:
        'Setting this endorsement back to Draft will make it editable again. It must then be returned to Review to complete the review process.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, return to Draft' },
      },
      icon: { type: 'warning' },
    }),
  },
  PUBLISHED: {
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Publish template?',
      content: 'Publishing this reviewed template will make it available to use when creating new contracts.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, publish template' },
      },
      icon: { type: 'valid' },
    }),
  },
  FIRM_ORDER: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Set contract to Firm Order?',
      content: 'Setting this contract to Firm Order will lock it from further edits and mark it as ready to be bound.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, update contract' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
  },
  FINAL: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Ready to finalise contract?',
      content:
        'By setting this contract to Final, it will be locked. Any further changes must be made as endorsements or through a renewal.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, finalise contract' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Ready to finalise endorsement?',
      content:
        'By setting this endorsement to Final, it will be locked. Any further changes must be made as a new endorsement.',
      buttons: {
        cancel: true,
        confirm: { text: 'Yes, finalise endorsement' },
      },
      icon: { type: 'valid' },
      validation: { required: true },
    }),
  },
  ARCHIVED: {
    [DocumentMode.SUBMISSIONS]: () => ({
      title: 'Archive contract?',
      content:
        'Setting this contract to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive contract',
        },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.TEMPLATES]: () => ({
      title: 'Archive template?',
      content:
        'Setting this template to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive template',
        },
      },
      icon: { type: 'warning' },
    }),
    [DocumentMode.ENDORSEMENTS]: () => ({
      title: 'Archive endorsement?',
      content:
        'Setting this endorsement to Archived will take it out of active use. It must be returned to Draft to make it editable again.',
      buttons: {
        cancel: true,
        confirm: {
          text: 'Yes, archive endorsement',
        },
      },
      icon: { type: 'warning' },
    }),
  },
};
